<div class="rcs-scope rcs-cols" data-testid="rcs-editor">
  <div class="rcs-stack">
    <!-- Remetente: só agente Ativo pode ser escolhido. Os outros aparecem travados,
         com a etapa, para o cliente entender por que não pode. -->
    <section class="rcs-card rcs-stack">
      <div class="rcs-field">
        <label for="rcs-agent">Agente (remetente)</label>
        <app-skeleton *ngIf="loadingAgents" variant="text" [count]="1" label="Carregando os agentes"
          data-testid="rcs-agent-loading"></app-skeleton>
        <app-search-select *ngIf="!loadingAgents" [options]="agentOptions" [ngModel]="agentId"
          (selectionChange)="selectAgent($event)" placeholder="Escolha o agente" searchPlaceholder="Pesquisar agente…"
          emptyText="Nenhum agente encontrado" noun="agentes" testId="rcs-agent-select"></app-search-select>
        <p class="rcs-hint">
          Só o agente Ativo pode ser escolhido.
          <a routerLink="/rcs/agents" *ngIf="!loadingAgents && !activeAgents.length" data-testid="rcs-no-active-agent">
            Nenhum agente ativo: veja seus agentes.
          </a>
        </p>
        <p class="rcs-error" *ngIf="agentsFailed">Não foi possível carregar os agentes.</p>
      </div>

      <div class="rcs-notice rcs-notice--bad" *ngIf="selectedAgent && !agentActive" data-testid="rcs-agent-inactive">
        <i class="fa fa-pause-circle"></i>
        <span *ngIf="context === 'sequence'">
          <strong>Etapa pausada:</strong> o agente {{ selectedAgent.name }} está
          {{ stageLabels[selectedAgent.stage] | lowercase }}. Nenhum lead recebe esta etapa e nada é cobrado até ele
          voltar a ficar ativo.
        </span>
        <span *ngIf="context !== 'sequence'">
          <strong>O agente {{ selectedAgent.name }} está {{ stageLabels[selectedAgent.stage] | lowercase }}.</strong>
          Escolha um agente ativo para enviar.
        </span>
      </div>
    </section>

    <section class="rcs-card rcs-stack">
      <h4 class="rcs-card__title"><i class="fa fa-comment-o"></i> Mensagem</h4>

      <div class="rcs-format-choice" role="group" aria-label="Formato da mensagem">
        <button type="button" class="sf-btn sf-btn--sm" [class.is-active]="!carousel" [attr.aria-pressed]="!carousel" (click)="setCarousel(false)">Basic / Single</button>
        <button type="button" class="sf-btn sf-btn--sm" [class.is-active]="carousel" [attr.aria-pressed]="carousel" (click)="setCarousel(true)" data-testid="rcs-enable-carousel">Carrossel · 2 a 10 cards</button>
      </div>
      <ng-container *ngIf="carousel">
        <p class="rcs-hint">No modelo Google, cada carrossel conta como uma mensagem por destinatário. A tarifa da Pingoo e o preço final do produto ainda não foram confirmados.</p>
        <div class="rcs-carousel-editor-tabs" role="tablist" aria-label="Cards do carrossel">
          <button #cardTab type="button" *ngFor="let card of cards; let i = index" class="sf-btn sf-btn--sm rcs-carousel-tab"
            [class.rcs-carousel-tab--selected]="i === cardIndex" (click)="selectCard(i)" [attr.aria-selected]="i === cardIndex" role="tab">
            <i *ngIf="i === cardIndex" class="fa fa-check-circle" aria-hidden="true"></i>
            Card {{ i + 1 }}{{ card.title ? ' · ' + card.title : '' }}<span *ngIf="i === cardIndex"> · selecionado</span>
          </button>
        </div>
        <div class="rcs-carousel-editor-actions">
          <span>{{ cards.length }}/10 cards</span>
          <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="moveCard(-1)" [disabled]="cardIndex === 0" aria-label="Mover card para a esquerda">←</button>
          <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="moveCard(1)" [disabled]="cardIndex === cards.length - 1" aria-label="Mover card para a direita">→</button>
          <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="removeCard()" [disabled]="cards.length <= 2" data-testid="rcs-remove-card">Remover card {{ cardIndex + 1 }}</button>
          <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" (click)="addCard()" [disabled]="cards.length >= 10" data-testid="rcs-add-card">+ Adicionar card</button>
        </div>
      </ng-container>

      <div class="rcs-field">
        <label for="rcs-title">Título do card <span class="rcs-field__count">(opcional)</span></label>
        <input id="rcs-title" type="text" class="form-control" maxlength="200" [(ngModel)]="title"
          (ngModelChange)="onChange()" data-testid="rcs-title" />
      </div>

      <div class="rcs-field">
        <span class="rcs-field__label">Imagem <span class="rcs-field__count">(opcional)</span></span>
        <div class="rcs-media-pick">
          <div class="rcs-media-pick__thumb">
            <img *ngIf="mediaUrl" [src]="mediaUrl" alt="Imagem escolhida" />
            <span *ngIf="!mediaUrl">sem imagem</span>
          </div>
          <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="openGallery()"
            data-testid="rcs-open-gallery">
            {{ mediaUrl ? 'Trocar imagem' : 'Escolher da galeria' }} <i class="fa fa-picture-o"></i>
          </button>
          <button type="button" class="sf-btn sf-btn--ghost sf-btn--sm" *ngIf="mediaUrl" (click)="removeMedia()"
            data-testid="rcs-remove-media">
            Tirar imagem
          </button>
        </div>
      </div>

      <div class="rcs-field">
        <label for="rcs-text">
          Texto
          <span class="rcs-field__count" data-testid="rcs-text-count">
            {{ textLength }} caracteres com as variáveis de exemplo · {{ text.length }} / {{ textMax }} no editor
          </span>
        </label>
        <textarea #textArea id="rcs-text" class="form-control" rows="4" [maxlength]="textMax" [(ngModel)]="text" (ngModelChange)="onChange()"
          data-testid="rcs-text"></textarea>
      </div>

      <div class="rcs-vars" *ngIf="textVariables.length">
        Variáveis:
        <button type="button" *ngFor="let variable of textVariables" [title]="variable.label" (click)="insertVariable(variable)"
          data-testid="rcs-variable">
          + {{ '{' + variable.tag + '}' }}
        </button>
      </div>

      <div class="rcs-button-row" *ngFor="let row of visibleRows; let index = index" data-testid="rcs-button-row">
        <div class="rcs-field">
          <label [for]="'rcs-button-type-' + index">Botão {{ index + 1 }}</label>
          <select [id]="'rcs-button-type-' + index" class="form-select" [(ngModel)]="row.type" (ngModelChange)="onChange()">
            <option *ngFor="let type of buttonTypes" [ngValue]="type.value">{{ type.label }}</option>
          </select>
        </div>
        <div class="rcs-field">
          <label [for]="'rcs-button-label-' + index">Texto do botão</label>
          <input [id]="'rcs-button-label-' + index" type="text" class="form-control" [maxlength]="buttonLabelMax"
            [(ngModel)]="row.label" (ngModelChange)="onChange()" />
        </div>
        <div class="rcs-field">
          <label [for]="'rcs-button-value-' + index">{{ buttonValueLabel(row.type) }}</label>
          <input #valueInput [id]="'rcs-button-value-' + index" type="text" class="form-control" [(ngModel)]="row.value"
            (ngModelChange)="onChange()" [placeholder]="buttonPlaceholder(row.type)" />
          <!-- Só na automação: as variáveis de URL que a integração traz. -->
          <div class="rcs-vars rcs-vars--link" *ngIf="row.type === 'url' && linkVariables.length"
            [attr.data-testid]="'rcs-link-vars-' + index">
            Links disponíveis:
            <button type="button" *ngFor="let variable of linkVariables" [title]="variable.label"
              (click)="insertButtonVariable(row, variable, valueInput)" data-testid="rcs-link-variable">
              + {{ '{' + variable.tag + '}' }}
            </button>
          </div>
          <div class="rcs-vars rcs-vars--link" *ngIf="row.type === 'pix' && pixVariables.length"
            [attr.data-testid]="'rcs-pix-vars-' + index">
            Variáveis disponíveis:
            <button type="button" *ngFor="let variable of pixVariables" [title]="variable.label"
              (click)="insertButtonVariable(row, variable, valueInput)" data-testid="rcs-pix-variable">
              + {{ '{' + variable.tag + '}' }}
            </button>
          </div>
        </div>
      </div>
      <p class="rcs-hint">
        "Copiar código Pix" abre uma página nossa, com a marca do agente, onde o código é copiado: o RCS não tem botão de
        copiar.
      </p>
      <div class="rcs-button-actions">
        <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" *ngIf="!showSecondButton"
          (click)="addSecondButton()" data-testid="rcs-add-button">
          <i class="fa fa-plus"></i> Adicionar botão
        </button>
        <button type="button" class="sf-btn sf-btn--danger sf-btn--sm" *ngIf="showSecondButton"
          (click)="removeSecondButton()" data-testid="rcs-remove-button">
          <i class="fa fa-trash-o"></i> Remover
        </button>
      </div>

      <!-- Formato detectado: a mesma regra da cobrança, com o porquê. -->
      <div class="rcs-format" [class.rcs-format--basic]="type === 'basic'" data-testid="rcs-format">
        <div class="rcs-format__title">
          Formato detectado
          <span class="rcs-pill" [class.rcs-pill--ok]="type === 'basic'" [class.rcs-pill--violet]="type === 'single'"
            data-testid="rcs-format-type">
            RCS {{ carousel ? 'Carrossel' : (type === 'single' ? 'Single' : 'Basic') }}
          </span>
        </div>
        <ng-container *ngIf="type === 'basic'">
          <p class="rcs-hint">
            Só texto, até {{ basicMax }} caracteres. Link no texto é encurtado e conta no limite.
          </p>
        </ng-container>
        <ng-container *ngIf="type === 'single'">
          <ul data-testid="rcs-format-reasons">
            <li *ngFor="let reason of reasons">{{ reason }}</li>
          </ul>
          <p class="rcs-hint">
            <ng-container *ngIf="!carousel">Para sair como Basic: texto até {{ basicMax }} caracteres, sem título, sem imagem e sem botão.</ng-container>
            <ng-container *ngIf="carousel">Cada carrossel é enviado como uma mensagem única por contato.</ng-container>
          </p>
        </ng-container>
      </div>

      <div class="rcs-notice rcs-notice--bad" *ngIf="problems.length" data-testid="rcs-problems">
        <i class="fa fa-exclamation-circle"></i>
        <ul><li *ngFor="let problem of problems">{{ problem }}</li></ul>
      </div>
    </section>
  </div>

  <!-- Prévia no celular: com RCS (card da marca) e sem RCS (o SMS que sai pela rota de SMS). -->
  <aside class="rcs-cols__side rcs-stack">
    <div class="sf-btn-group" role="tablist" aria-label="Prévia">
      <button type="button" class="sf-btn sf-btn--sm" role="tab" [class.is-active]="view === 'rcs'"
        [attr.aria-selected]="view === 'rcs'" (click)="setView('rcs')" data-testid="rcs-view-rcs">Com RCS</button>
      <button type="button" class="sf-btn sf-btn--sm" role="tab" [class.is-active]="view === 'sms'"
        [attr.aria-selected]="view === 'sms'" (click)="setView('sms')" data-testid="rcs-view-sms">
        Sem RCS (vira SMS)
      </button>
    </div>

    <app-rcs-phone [view]="view" [type]="type" [brand]="selectedAgent" [title]="title" [mediaUrl]="mediaUrl" [cards]="phoneCards"
      [text]="resolvedText" [smsText]="smsText" [smsLength]="smsLength" [buttons]="phoneButtons" [interactive]="true"></app-rcs-phone>

    <p class="rcs-hint rcs-hint--center" *ngIf="view === 'sms'">
      Gerado sozinho: texto do card + link do botão 1. Título e imagem ficam de fora.
    </p>
    <p class="rcs-hint rcs-hint--center" *ngIf="view === 'rcs'">Prévia com o contato de exemplo Carlos.</p>
    <ng-container *ngIf="view === 'rcs' && type === 'single'">
      <p class="rcs-hint rcs-hint--center rcs-hint--link" *ngFor="let link of previewLinks" data-testid="rcs-preview-link">
        <i class="fa fa-external-link"></i> {{ link.label }} abre <code>{{ link.url }}</code>
      </p>
    </ng-container>
    <p class="rcs-hint rcs-hint--center" *ngIf="previewFailed && !previewError" data-testid="rcs-preview-local">
      Prévia calculada no navegador: o servidor não respondeu. O formato final é o do servidor.
    </p>
    <p class="rcs-error rcs-hint--center" *ngIf="previewError" data-testid="rcs-preview-rejected">
      <i class="fa fa-exclamation-circle"></i> O servidor recusou este conteúdo: {{ previewError }}
    </p>

    <!-- Quem usa o editor põe aqui o que mora ao lado da prévia (o custo, no envio em massa). -->
    <ng-content select="[rcsSide]"></ng-content>
  </aside>
</div>
